import { useState } from 'react'
import TabsSection from '../../../components/purchaseInvoices/invoiceManagement/TabsSection';
import FileUploadDrawer from '../../../components/purchaseInvoices/invoiceManagement/FileUploadDrawer';
import ManualInvoiceDialog from './ManualInvoiceDialog.';
import { CssBaseline, Box } from "@mui/material";

const SupplierInvoiceFiles = ({
  highlightedInvoiceId,
  clarificationId,
  onHighlightComplete
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [manualDrawerOpen, setManualDrawerOpen] = useState(false);

  const handleOpenDrawer = () => setDrawerOpen(true);
  const handleCloseDrawer = () => setDrawerOpen(false);
  const handleOpenManualDrawer = () => setManualDrawerOpen(true);
  const handleCloseManualDrawer = () => setManualDrawerOpen(false);

  return (
    <div>
      <CssBaseline />
      <Box sx={{ padding: 4, backgroundColor: "#FFFFFF", minHeight: "100vh" }}>
        <TabsSection
          onOpenDrawer={handleOpenDrawer}
          onOpenManualDrawer={handleOpenManualDrawer}
          highlightedInvoiceId={highlightedInvoiceId}
          clarificationId={clarificationId}
          onHighlightComplete={onHighlightComplete}
        />
        <FileUploadDrawer open={drawerOpen} onClose={handleCloseDrawer} />
        <ManualInvoiceDialog open={manualDrawerOpen} onClose={handleCloseManualDrawer} />
      </Box>
    </div>
  )
}

export default SupplierInvoiceFiles